import { type PaginatedQueryParams } from 'queries/queries-utils'

interface GetScenarioByIdParams {
  scenarioId: string
  teamId: string
}

interface GetScenarioByIdAndRunNumberParams extends GetScenarioByIdParams {
  runNumber: number
}

interface GetScenarioRunsByIdPaged extends GetScenarioByIdParams {
  forward: boolean
  limit: number
  runNumber?: number
}

export const scenariosQueryKeys = {
  getScenariosActivePaged: (
    params: { teamId: string } & PaginatedQueryParams
  ) => ['scenarios/active/paged', params] as const,
  getScenariosActiveRuns: (query: Record<string, string | number | null>) =>
    ['scenarios/active-runs', query] as const,
  getCompletedPaged: (params: { pageSize: number; teamId: string }) =>
    ['scenarios/completed/paged', params] as const,
  getScenarioById: ({ scenarioId, ...query }: GetScenarioByIdParams) =>
    [`/scenarios/${scenarioId}`, query] as const,
  getScenarioRunDetails: ({
    scenarioId,
    runNumber,
    ...params
  }: GetScenarioByIdParams & { runNumber: number }) =>
    [`/scenarios/${scenarioId}/runs/${runNumber}`, params] as const,
  getScenarioRunMetrics: ({
    scenarioId,
    runNumber,
    ...params
  }: GetScenarioByIdParams & { runNumber: number }) =>
    [`/metrics/scenarios/${scenarioId}/runs/${runNumber}`, params] as const,
  getScenarioRunsByIdPaged: ({
    scenarioId,
    ...params
  }: GetScenarioRunsByIdPaged) =>
    [`/scenarios/${scenarioId}/runs/paged`, params] as const,
  getScenarioSchedulesById: ({
    scenarioId,
    ...params
  }: GetScenarioByIdParams) =>
    [`/scenarios/${scenarioId}/schedules`, params] as const
}

export const scenariosMutationKeys = {
  haltScenario: ({
    scenarioId,
    runNumber,
    ...params
  }: GetScenarioByIdAndRunNumberParams) =>
    [`/scenarios/halt/${scenarioId}/runs/${runNumber}`, params] as const,
  runScenario: ({ scenarioId, ...params }: GetScenarioByIdParams) =>
    [`/scenarios/${scenarioId}/runs`, params] as const
}
